import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=010424dc"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__